import axios from 'axios';
const base = 'subtipotk';
function getAll(query = null) {
    return axios.get(base, {
        params: query
    });
}

function register(data) {
    return axios.post(base, data);
}


function update(data) {
    return axios.put([base, data.id_sttk].join('/'), data);
}

function destroy(id) {
    return axios.delete([base, id].join('/'));
}

const SubTipoTicketService = {
    getAll: getAll,
    register: register,
    update: update,
    destroy: destroy
};
export default SubTipoTicketService;
